import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, HostListener} from '@angular/core';
import { NJDocData, NJDocDefTemplate, DocdefDataVM, DOData, childSearchReq, componentVM, modalParams, ModalParamsElem } from '../DOData';
import { wrappersService } from '../wrappers/wrappers.service';
import { SectionTableComponent } from '../section-table/section-table.component';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridInternalAgGridComponent } from '../grid-internal-ag-grid/grid-internal-ag-grid.component';
import { DOLabelComponent } from '../dolabel/dolabel.component';
import { DOTextBoxComponent } from '../dotext-box/dotext-box.component';
import { GridNCheckboxComponent } from '../grid-ncheckbox/grid-ncheckbox.component';
import { DodropDownComponent } from '../dodrop-down/dodrop-down.component';
import { faStreetView } from '@fortawesome/free-solid-svg-icons';
import { DropdownCommentsComponent } from '../dropdown-comments/dropdown-comments.component';
import { Stream } from 'stream';
@Component({
    selector: 'cylib-map-google-map',
    templateUrl: './map-google-map.component.html',
    styleUrls: ['./map-google-map.component.css']
})
export class MapGoogleMapComponent implements OnInit {
    private maxRow = -1;

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>

    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;

    @Input() isValid: boolean = true;
    @Input() isHideTitles: boolean = false;
    @Input() isEnabled: boolean = true;

    @Input() isPopUpYesNo: string;
    @Input() isPopUpSelected: boolean = false;
    @Input() modal_title: string;
    @Input() modal_content: string;

    @Input() tab: string;
    @Input() gridTemplateCode: string;
    @Input() providerSpecialty: string;
    @Input() program: string;
    @Input() providerType: string;
    @Input() siteCIMIDS: string;
    @Input() siteCIMIDRequired: boolean;
    @Input() reOpenPopup: boolean;
    //@Input() MemberID: string;

    _MemberID: string;
    SelectedCBGroup: DOData;
    ProviderTypeSelection: string;
    get MemberID(): string {
        return this._MemberID;
    }
    @Input() set MemberID(value: string) {
        if (value) 
        {
            if (value != '') 
            {
                //let d: DOData = new DOData;
                this._MemberID = value;
                //this.searchForYouth(d, "", "");
            }
        }
    }

    public loaderKey: string = "Wrappers";
    private strDocDefTypeSubCode: string = "Wrappers";

    private primitivesGrid: SectionTableComponent;

    private CIMIDSTemplateCode: string = "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_TextBox_CIMIDSplacehold";

    private diaglogType_MyCaseload: string = "MyCaseload";
    private diaglogType_AgencyCases: string = "AgencyCases";

    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();

    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();

    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    public map: google.maps.Map;
    public listDocdata: Array<Array<DOData>>;
    public datasource;

    @ViewChild('map') mapElement: any;

    height: Number = 600;
    width: Number = 900;

    private markers: google.maps.Marker[] = [];

    constructor(
        private data: DocDefPrimLibService
        , public activeModal: NgbActiveModal
        , private wrapLib: wrappersService
        , private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tab;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = this.gridTemplateCode;

        if (this.siteCIMIDRequired) {
            var elem: ModalParamsElem = new ModalParamsElem();
            elem.value = this.siteCIMIDS;
            elem.param = this.CIMIDSTemplateCode;
            params.lstModalParams.push(elem);
        }

        this.data.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.data.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst)
                        }

                        this.GetDODataItems(localListDocdata);

                        this.listDocdata = localListDocdata;

                    }
                },
                (err: any) => console.log(err),
                () => {
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    if (typeof (Event) === 'function') {
                        // modern browsers
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        //This will be executed on old browsers and especially IE
                        var resizeEvent = window.document.createEvent('UIEvents');
                        resizeEvent.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(resizeEvent);
                    }
                    //this.ModalWait.close("");

                    this.addMapsScript();

                }
            );
    }

    cbProvBH: DOData;
    cbProvIDD: DOData;
    cbProvSU: DOData;
    GetDODataItems(ListDocdata: DOData[][]) 
    {
        this.cbProvBH = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType", ListDocdata);
        this.cbProvIDD = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeIDD", ListDocdata);
        this.cbProvSU = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeSA", ListDocdata);
        this.ProviderTypeSelection = "BH";
    }

    GetDODataItem(templateCode: string, ListDocdata: DOData[][]) : DOData
    {
        let match: DOData;
        for (let value of ListDocdata)
        {
            for (let childvalue of value)
            {
                if (childvalue.njDocDefTemplate.templateCode == templateCode)
                {
                    match = childvalue;
                    break;
                }
            }
            if (match)
                break;
        }
        return match;
    }

    addMapsScript() {
        let APIKey: string = "AIzaSyDNy6iv5NpG7EtsXppgIKRslciI400TiCo";
        let googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=" + APIKey;

        if (!document.querySelectorAll(`[src="${googleMapsUrl}"]`).length) {
            document.body.appendChild(Object.assign(
                document.createElement('script'), {
                    type: 'text/javascript',
                    src: googleMapsUrl,
                    onload: () => this.initMap()
                }));
        } else {
            this.initMap();
        } 
    }

    initMap(): void {
        // read map center information
        let Default_Lat = 40.208321;
        let Default_long = -75.035142;
        // read zoomlevel information
        let zoomlevel = 8;
        let mapTypeId = google.maps.MapTypeId.ROADMAP;

        const mapProperties = {
            center: new google.maps.LatLng(Default_Lat, Default_long),
            zoom: zoomlevel,
            mapTypeId: mapTypeId,
            streetViewControl: false,
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);

        this.loadCountyLayer();
        // set up the style rules and events for google.maps.Data
        this.map.data.setStyle(this.styleFeature);
        this.map.data.addListener('mouseover', this.mouseInToRegion);
        this.map.data.addListener('mouseout', this.mouseOutOfRegion);

    }

    /** Loads the county boundary polygons from a GeoJSON source. */
    loadCountyLayer() {
        // load nj county outline polygons from a GeoJson file
        this.map.data.loadGeoJson('https://opendata.arcgis.com/datasets/5f45e1ece6e14ef5866974a7b57d3b95_1.geojson', { idPropertyName: 'COUNTY' });
        let d: DOData = new DOData;
        if(this.MemberID)
            this.searchForYouth(d, "", "");
    }

    removeCountyLayer() {
        let thefeatures: google.maps.Data.Feature[] = [];

        this.map.data.forEach(function (feature: google.maps.Data.Feature) {
            thefeatures.push(feature);
        });

        for (let i = 0; i < thefeatures.length; i++) {
            this.map.data.remove(thefeatures[i]);
        }
    }

    ///**
    //*  https://developers.google.com/maps/documentation/javascript/combining-data
    //* Applies a gradient style based on the 'census_variable' column.
    //* This is the callback passed to data.setStyle() and is called for each row in
    //* the data set.  Check out the docs for Data.StylingFunction.
    //*
    //* @param {google.maps.Data.Feature} feature
    //*/
    styleFeature(feature: google.maps.Data.Feature) {

        var outlineWeight = 0.5, zIndex = 1;
        if (feature.getProperty('county') === 'hover') {
            outlineWeight = zIndex = 2;
        }

        return {
            strokeWeight: outlineWeight,
            strokeColor: '#fff',
            zIndex: zIndex,
            fillColor: 'hsl(' + 5 + ',' + 0 + '%,' + 25 + '%)',
            fillOpacity: 0.15,
            visible: true

        };
    }

    ///**
    //* Responds to the mouse-in event on a map shape (state).
    //*
    //* @param {?google.maps.MouseEvent} e
    //*/
    mouseInToRegion(e) {
        // set the hover state so the setStyle function can change the border
        e.feature.setProperty('county', 'hover');
        document.getElementById('data-label').textContent = "County";
        document.getElementById('data-value').textContent = e.feature.getProperty('COUNTY');
        document.getElementById('data-box').style.display = 'block';
    }

    ///**
    //* Responds to the mouse-out event on a map shape (state).
    //*
    //* @param {?google.maps.MouseEvent} e
    //*/
    mouseOutOfRegion(e) {
        // // reset the hover state, returning the border to normal
        e.feature.setProperty('county', 'normal');
        document.getElementById('data-box').style.display = 'none';
    }

    SiteTypeFromDropDownSelection: string; 
    loadProviders(showProviders: Number, cbDocData?: DOData) {
        let lat: Number;
        let long: Number;

        let grdProivders: GridInternalAgGridComponent = this.primitivesGrid.GridInternalAgGridComponents.first;
        let gridNCheckBoxProivders: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.last;

        // get template ids
        let templateId_siteType: Number;
        let templateId_providerName: Number;
        let templateId_providerType: Number;
        let templateId_lat: Number;
        let templateId_long: Number;
        let templateId_Street: Number;
        let templateId_City: Number;
        let templateId_State: Number;
        let templateId_Zip: Number;
        let templateId_GenderServed: Number;
        let templateId_AvailableBeds: Number;
        let templateId_Admissions: Number;
        let templateCode_Admissions: string = "";
        let templateId_ContactEmail: Number;
        let templateId_ContactPhone: Number;
        let templateId_ContactPerson: Number;
        let templateId_SiteTypeClass: Number;
        let templateId_ProviderSpecialty: Number;
        let templateId_Languages: Number;
        let templateId_Specializations: Number;
        let templateId_Counties: Number;
        let templateId_PgmProviderType: Number;
        

        let location: google.maps.LatLng;
        let siteType: string = "";
        let providerName: string = "";
        let providerType: string = "";
        let Street: string;
        let City: string;
        let State: string;
        let Zip: string;
        let GenderServed: string;
        let AvailableBeds: string;
        let Admissions: string;
        let ContactEmail: string = "";
        let ContactPerson: string = "";
        let ContactPhone: string = "";
        let ProviderSpecialty: string = "";
        let Languages: string = "";
        let Specializations: string = "";
        let Counties: string = "";
        let PgmProviderType: string="";

        for (let template of grdProivders.lstChildDocDefTemplate) {
            if (template.dictCustomParameters['SiteType'] == "Yes")
                templateId_siteType = template.docDefTemplateID;
            if (template.dictCustomParameters['ProviderName'] == "Yes")
                templateId_providerName = template.docDefTemplateID;
            if (template.dictCustomParameters['ProviderType'] == "Yes")
                templateId_providerType = template.docDefTemplateID;
            if (template.dictCustomParameters['Lat'] == "Yes")
                templateId_lat = template.docDefTemplateID;
            if (template.dictCustomParameters['Long'] == "Yes")
                templateId_long = template.docDefTemplateID;
            if (template.dictCustomParameters['Street'] == "Yes")
                templateId_Street = template.docDefTemplateID;
            if (template.dictCustomParameters['City'] == "Yes")
                templateId_City = template.docDefTemplateID;
            if (template.dictCustomParameters['State'] == "Yes")
                templateId_State = template.docDefTemplateID;
            if (template.dictCustomParameters['Zip'] == "Yes")
                templateId_Zip = template.docDefTemplateID;
            if (template.dictCustomParameters['GenderServed'] == "Yes")
                templateId_GenderServed = template.docDefTemplateID;
            if (template.dictCustomParameters['AvailableBeds'] == "Yes")
                templateId_AvailableBeds = template.docDefTemplateID;
            if (template.dictCustomParameters['Admissions'] == "Yes") {
                templateId_Admissions = template.docDefTemplateID;
                templateCode_Admissions = template.templateCode;
            }
                
            if (template.dictCustomParameters['SiteTypeClass'] == "Yes")
                templateId_SiteTypeClass = template.docDefTemplateID;
            if (template.dictCustomParameters['ContactPhone'] == "Yes")
                templateId_ContactPhone = template.docDefTemplateID;
            if (template.dictCustomParameters['ContactEmail'] == "Yes")
                templateId_ContactEmail = template.docDefTemplateID;
            if (template.dictCustomParameters['Contact'] == "Yes")
                templateId_ContactPerson = template.docDefTemplateID;
            if (template.dictCustomParameters['ProviderSpecialty'] == "Yes")
                templateId_ProviderSpecialty = template.docDefTemplateID;
            if (template.dictCustomParameters['Languages'] == "Yes")
                templateId_Languages = template.docDefTemplateID;
            if (template.dictCustomParameters['Specializations'] == "Yes")
                templateId_Specializations = template.docDefTemplateID;
            if (template.dictCustomParameters['Counties'] == "Yes")
                templateId_Counties = template.docDefTemplateID;
            if (template.dictCustomParameters['PgmProviderType'] == "Yes")
                templateId_PgmProviderType = template.docDefTemplateID;
        }

        let lstDocDataLocal: Array<NJDocData> = new Array<NJDocData>();

        if (cbDocData)
        {
            if (grdProivders.lstDocData) 
            {
                lstDocDataLocal = grdProivders.lstDocData;
                //
            }

            if (cbDocData.njDocData.dataValue == "1") //add flags
            {

                let SiteTypeClass: string = ""; 
                for (var rowIndex = 0; rowIndex < grdProivders._getRows.length; rowIndex++) 
                {
                    let docDataRowID = grdProivders._getRows[rowIndex];
                    let data_SiteTypeClass: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_SiteTypeClass && templateId_SiteTypeClass) });

                    if (data_SiteTypeClass.length > 0)
                        SiteTypeClass = data_SiteTypeClass[0].dataValue;
                    else
                        SiteTypeClass = "";

                    if (SiteTypeClass == "" || SiteTypeClass.includes(this.ProviderTypeSelection)  && this.ProviderTypeSelection != "") 
                    {

                        //templateId_SiteTypeClass
                        let data_SiteType: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_siteType && templateId_siteType) });

                        if (data_SiteType.length == 1)
                            siteType = data_SiteType[0].dataValue;
                        else
                            siteType = "";

                        //if (siteType != "" && this.SiteTypeFromDropDownSelection !="") {
                        //    siteType ! = this.SiteTypeFromDropDownSelection
                        //    continue;
                        //}

                        if (siteType == cbDocData.njDocDefTemplate.dictCustomParameters["Composite"])
                        {
                            //this.providerType = siteType;

                            let data_ProviderType: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_providerType && templateId_providerType) });
                            if (data_ProviderType.length == 1)
                                providerType = data_ProviderType[0].dataValue;
                            else
                                providerType = "";


                            let data_ProviderName: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_providerName && templateId_providerName) });
                            if (data_ProviderName.length == 1)
                                providerName = data_ProviderName[0].dataValue;
                            else
                                providerName = "";

                            let data_lat: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_lat && templateId_lat) });
                            if (data_lat.length == 1)
                                lat = Number(data_lat[0].dataValue);
                            else
                                lat = Number(0);

                            let data_long: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_long && templateId_long) });
                            if (data_long.length == 1)
                                long = Number(data_long[0].dataValue);
                            else
                                long = Number(0);

                            let data_Street: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Street && templateId_Street) });
                            if (data_Street.length == 1)
                                Street = data_Street[0].dataValue;
                            else
                                Street = "";

                            let data_City: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_City && templateId_City) });
                            if (data_City.length == 1)
                                City = data_City[0].dataValue;
                            else
                                City = "";

                            let data_State: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_State && templateId_State) });
                            if (data_State.length == 1)
                                State = data_State[0].dataValue;
                            else
                                State = "";

                            let data_Zip: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Zip && templateId_Zip) });
                            if (data_Zip.length == 1)
                                Zip = data_Zip[0].dataValue;
                            else
                                Zip = "";

                            let data_ContactPhone: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactPhone && templateId_ContactPhone) });
                            if (data_ContactPhone.length == 1)
                                ContactPhone = data_ContactPhone[0].dataValue;
                            else
                                ContactPhone = "";

                            let data_ContactEmail: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactEmail && templateId_ContactEmail) });
                            if (data_ContactEmail.length == 1)
                                ContactEmail = data_ContactEmail[0].dataValue;
                            else
                                ContactEmail = "";

                            let data_ContactPerson: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactPerson && templateId_ContactPerson) });
                            if (data_ContactPerson.length == 1)
                                ContactPerson = data_ContactPerson[0].dataValue;
                            else
                                ContactPerson = "";

                            let data_GenderServed: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_GenderServed && templateId_GenderServed) });
                            if (data_GenderServed.length == 1)
                                GenderServed = data_GenderServed[0].dataValue;
                            else
                                GenderServed = "";

                            let data_AvailableBeds: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_AvailableBeds && templateId_AvailableBeds) });
                            if (data_AvailableBeds.length == 1)
                                AvailableBeds = data_AvailableBeds[0].dataValue;
                            else
                                AvailableBeds = "";

                            let data_Admissions: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Admissions && templateId_Admissions) });
                            if (data_Admissions.length == 1)
                                Admissions = data_Admissions[0].dataValue;
                            else
                                Admissions = "";

                            let data_ProviderSpecialty: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ProviderSpecialty && templateId_ProviderSpecialty) });
                            if (data_ProviderSpecialty.length == 1)
                                ProviderSpecialty = data_ProviderSpecialty[0].dataValue;
                            else
                                ProviderSpecialty = "";

                            let data_Languages: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Languages && templateId_Languages) });
                            if (data_Languages.length == 1)
                                Languages = data_Languages[0].dataValue;
                            else
                                Languages = "";

                            let data_Specializations: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Specializations && templateId_Specializations) });
                            if (data_Specializations.length == 1)
                                Specializations = data_Specializations[0].dataValue;
                            else
                                Specializations = "";

                            let data_Counties: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Counties && templateId_Counties) });
                            if (data_Counties.length == 1)
                                Counties = data_Counties[0].dataValue;
                            else
                                Counties = "";

                            let data_PgmProviderType: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_PgmProviderType && templateId_PgmProviderType) });
                            if (data_PgmProviderType.length == 1)
                                PgmProviderType = data_PgmProviderType[0].dataValue;
                            else
                                PgmProviderType = "";

                            // *************************************************
                            // if no geo data nothing to load for the provider
                            // *************************************************
                            if (lat != 0 && long != 0) 
                            {
                                location = new google.maps.LatLng(Number(lat), Number(long));

                                let detail: string = "";
                                if (this.providerType!="")
                                {
                                    detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                                    detail += "<BR/>" + providerType;
                                }

                                detail += "<BR/><BR/>" + "ADDRESS:";
                                detail += "<BR/>" + Street;
                                detail += "<BR/>" + City + ", " + State + " " + Zip;

                                if (ContactPerson != "")
                                {
                                    detail += "<BR/><BR/>" + "CONTACT:";
                                    detail += "<BR/>" + ContactPerson;
                                }
                                if (ContactPhone != "")
                                {
                                    detail += "<BR/><BR/>" + "CONTACT PHONE:";
                                    detail += "<BR/>" + ContactPhone;
                                }

                                if (this.program ==null || this.program =="") {
                                    ///////////////////////////////////////////////
                                    // if this is not coming from 
                                    // Provider Details Tab with program selection
                                    ///////////////////////////////////////////////
                                    if (ContactEmail != "") {
                                        detail += "<BR/><BR/>" + "CONTACT EMAIL:";
                                        detail += "<BR/>" + ContactEmail;
                                    }
                                }

                                if (this.program !="") {
                                    (this.providerType != "")
                                    {
                                        if (siteType != this.providerType) {
                                            detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                                            detail += "<BR/>" + this.providerType;
                                        }
                                    }
                                }

                                if (this.providerSpecialty)
                                {
                                    if (this.providerSpecialty != "")
                                    {
                                        detail += "<BR/><BR/>" + "PROVIDER SPECIALTIES:";
                                        detail += "<BR/>" + this.providerSpecialty;
                                    }
                                }
                                if (this.program) {
                                    if (this.program != "") {
                                        detail += "<BR/><BR/>" + "PROGRAM:";
                                        detail += "<BR/>" + this.program;
                                    }

                                    detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                                    detail += "<BR/>" + PgmProviderType;

                                    detail += "<BR/><BR/>" + "PROVIDER SPECIALTIES:";
                                    detail += "<BR/>" + ProviderSpecialty;

                                    detail += "<BR/><BR/>" + "LANGUAGES:";
                                    detail += "<BR/>" + Languages;

                                    detail += "<BR/><BR/>" + "SPECIAlIZATIONS:";
                                    detail += "<BR/>" + Specializations;

                                    detail += "<BR/><BR/>" + "COUNTIES:";
                                    detail += "<BR/>" + Counties;
                                }

                                if (GenderServed == "B")
                                    GenderServed = "Served both Boys and Girls"
                                else if (GenderServed == "M")
                                    GenderServed = "Served Boys Only"
                                else if (GenderServed == "F")
                                    GenderServed = "Served Girls Only"

                                if (GenderServed != "")
                                    detail += "<BR/>" + GenderServed;

                                if (AvailableBeds != "" && Admissions != "" && templateCode_Admissions == "Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_Grid1_GEOData_TextBox_Admits") {

                                    let abed: number = +AvailableBeds;
                                    let beds: number = +Admissions;
                                    let intAdmission: number = 0;


                                    if (abed <= 0)
                                        detail += "<BR/>" + "Available Beds = 0";
                                    else
                                        detail += "<BR/>" + "Available Beds = " + abed.toString();

                                    intAdmission = beds;

                                    if (intAdmission <= 0)
                                        detail += "<BR/>" + "Admissions = 0";
                                    else
                                        detail += "<BR/>" + "Admissions =" + intAdmission.toString();

                                }
                                else {
                                    let abed: number = +AvailableBeds;
                                    let beds: number = +Admissions;
                                    let intAdmission: number = 0;


                                    if (abed <= 0)
                                        detail += "<BR/>" + "Available Beds = 0";
                                    else
                                        detail += "<BR/>" + "Available Beds = " + abed.toString();

                                    intAdmission = beds - abed;

                                    if (intAdmission <= 0)
                                        detail += "<BR/>" + "Admissions = 0";
                                    else
                                        detail += "<BR/>" + "Admissions =" + intAdmission.toString();
                                }

                                if (this.ChildLocation !=null) {
                                    // here we calculate distance from member  if member is initialized

                                    let miles:number = this.GetDistance(this.ChildLocation, location);

                                    detail += "<BR/>" + miles.toFixed(2) + " miles from the child";
                                }


                                switch (showProviders) 
                                {
                                    case this.SELECT_PROVIDERS_BY_CHECKBOXES:
                                        {
                                            // get the referfence from the gridncheckbox 
                                            // that contains SiteType information
                                            let templateId_SiteType: number = 0;

                                            let data_SiteTypeTemplate: Array<NJDocDefTemplate> =
                                                gridNCheckBoxProivders.lstChildDocDefTemplate.filter(
                                                    (d: NJDocDefTemplate) =>
                                                    {
                                                        return (
                                                            (d.dictCustomParameters["Composite"] == siteType && d.dictCustomParameters["Composite"])
                                                            || (d.dictCustomParameters["SiteType"] == siteType && d.dictCustomParameters["SiteType"])
                                                        )
                                                    }
                                                )

                                            if (data_SiteTypeTemplate.length == 1)
                                                templateId_SiteType = data_SiteTypeTemplate[0].docDefTemplateID;
                                            if (gridNCheckBoxProivders.IsSelected(templateId_SiteType) || siteType)
                                            {
                                                let _flagColor: string = "";
                                                if (cbDocData.njDocDefTemplate.dictCustomParameters["HexValue"])
                                                    _flagColor = cbDocData.njDocDefTemplate.dictCustomParameters["HexValue"];
                                                this.loadProvider(location, this.map, providerName, detail, _flagColor, siteType);
                                            }

                                            break;
                                        }
                                    case this.SELECT_ALL_PROVIDERS: {
                                        this.loadProvider(location, this.map, providerName, detail);
                                        break;
                                    }
                                }
                            }
                        }

                    }
                }
            }
            else //remove flags
            {
                this.clearDeselectedProviderMarker(cbDocData.njDocDefTemplate.dictCustomParameters["Composite"]);
            }
            
        }
        else
        {

            if (grdProivders.lstDocData) 
            {
                lstDocDataLocal = grdProivders.lstDocData;
            }

            let SiteTypeClass: string = ""; 
            for (var rowIndex = 0; rowIndex < grdProivders._getRows.length; rowIndex++) 
            {
                let docDataRowID = grdProivders._getRows[rowIndex];
                let data_SiteTypeClass: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_SiteTypeClass && templateId_SiteTypeClass) });

                if (data_SiteTypeClass.length > 0)
                    SiteTypeClass = data_SiteTypeClass[0].dataValue;
                else
                    SiteTypeClass = "";

                if (SiteTypeClass == "" || SiteTypeClass == this.ProviderTypeSelection && this.ProviderTypeSelection !="") {
                    let docDataRowID = grdProivders._getRows[rowIndex];
                    let data_SiteType: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_siteType && templateId_siteType) });

                    if (data_SiteType.length == 1)
                        siteType = data_SiteType[0].dataValue;
                    else
                        siteType = "";

                    let data_ProviderName: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_providerName && templateId_providerName) });
                    if (data_ProviderName.length == 1)
                        providerName = data_ProviderName[0].dataValue;
                    else
                        providerName = "";

                    let data_lat: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_lat && templateId_lat) });
                    if (data_lat.length == 1)
                        lat = Number(data_lat[0].dataValue);
                    else
                        lat = Number(0);

                    let data_long: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_long && templateId_long) });
                    if (data_long.length == 1)
                        long = Number(data_long[0].dataValue);
                    else
                        long = Number(0);

                    let data_Street: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Street && templateId_Street) });
                    if (data_Street.length == 1)
                        Street = data_Street[0].dataValue;
                    else
                        Street = "";

                    let data_City: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_City && templateId_City) });
                    if (data_City.length == 1)
                        City = data_City[0].dataValue;
                    else
                        City = "";

                    let data_State: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_State && templateId_State) });
                    if (data_State.length == 1)
                        State = data_State[0].dataValue;
                    else
                        State = "";

                    let data_Zip: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Zip && templateId_Zip) });
                    if (data_Zip.length == 1)
                        Zip = data_Zip[0].dataValue;
                    else
                        Zip = "";

                    let data_ContactPhone: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactPhone && templateId_ContactPhone) });
                    if (data_ContactPhone.length == 1)
                        ContactPhone = data_ContactPhone[0].dataValue;
                    else
                        ContactPhone = "";

                    let data_ContactEmail: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactEmail && templateId_ContactEmail) });
                    if (data_ContactEmail.length == 1)
                        ContactEmail = data_ContactEmail[0].dataValue;
                    else
                        ContactEmail = "";

                    let data_ContactPerson: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ContactPerson && templateId_ContactPerson) });
                    if (data_ContactPerson.length == 1)
                        ContactPerson = data_ContactPerson[0].dataValue;
                    else
                        ContactPerson = "";

                    let data_GenderServed: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_GenderServed && templateId_GenderServed) });
                    if (data_GenderServed.length == 1)
                        GenderServed = data_GenderServed[0].dataValue;
                    else
                        GenderServed = "";

                    let data_AvailableBeds: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_AvailableBeds && templateId_AvailableBeds) });
                    if (data_AvailableBeds.length == 1)
                        AvailableBeds = data_AvailableBeds[0].dataValue;
                    else
                        AvailableBeds = "";

                    let data_Admissions: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Admissions && templateId_Admissions) });
                    if (data_Admissions.length == 1)
                        Admissions = data_Admissions[0].dataValue;
                    else
                        Admissions = "";

                    let data_ProviderSpecialty: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_ProviderSpecialty && templateId_ProviderSpecialty) });
                    if (data_ProviderSpecialty.length == 1)
                        ProviderSpecialty = data_ProviderSpecialty[0].dataValue;
                    else
                        ProviderSpecialty = "";

                    let data_Languages: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Languages && templateId_Languages) });
                    if (data_Languages.length == 1)
                        Languages = data_Languages[0].dataValue;
                    else
                        Languages = "";

                    let data_Specializations: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Specializations && templateId_Specializations) });
                    if (data_Specializations.length == 1)
                        Specializations = data_Specializations[0].dataValue;
                    else
                        Specializations = "";

                    let data_Counties: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_Counties && templateId_Counties) });
                    if (data_Counties.length == 1)
                        Counties = data_Counties[0].dataValue;
                    else
                        Counties = "";

                    let data_PgmProviderType: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_PgmProviderType && templateId_PgmProviderType) });
                    if (data_PgmProviderType.length == 1)
                        PgmProviderType = data_PgmProviderType[0].dataValue;
                    else
                        PgmProviderType = "";

                    // *************************************************
                    // if no geo data nothing to load for the provider
                    // *************************************************
                    if (lat != 0 && long != 0) {

                        location = new google.maps.LatLng(Number(lat), Number(long));

                        let detail: string = "";

                        if (this.providerType != "") {
                            detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                            detail += "<BR/>" + providerType;
                        }

                        detail += "<BR/><BR/>" + "ADDRESS:";
                        detail += "<BR/>" + Street;
                        detail += "<BR/>" + City + ", " + State + " " + Zip;

                        if (ContactPerson != "") {
                            detail += "<BR/><BR/>" + "CONTACT:";
                            detail += "<BR/>" + ContactPerson;
                        }
                        if (ContactPhone != "") {
                            detail += "<BR/><BR/>" + "CONTACT PHONE:";
                            detail += "<BR/>" + ContactPhone;
                        }
                        if (this.program == null || this.program == "") {
                            ///////////////////////////////////////////////
                            // if this is not coming from 
                            // Provider Details Tab with program selection
                            ///////////////////////////////////////////////
                            if (ContactEmail != "") {
                                detail += "<BR/><BR/>" + "CONTACT EMAIL:";
                                detail += "<BR/>" + ContactEmail;
                            }
                            (this.providerType != "")
                            {
                                if (siteType != this.providerType) {
                                    detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                                    detail += "<BR/>" + this.providerType;
                                }
                            }
                        }

                        if (this.providerSpecialty) {
                            if (this.providerSpecialty != "") {
                                detail += "<BR/><BR/>" + "PROVIDER SPECIALTIES:";
                                detail += "<BR/>" + this.providerSpecialty;
                            }
                        }

                        if (this.program) {
                            if (this.program != "") {
                                detail += "<BR/><BR/>" + "PROGRAM:";
                                detail += "<BR/>" + this.program;
                            }

                            detail += "<BR/><BR/>" + "PROVIDER TYPE:";
                            detail += "<BR/>" + PgmProviderType;

                            detail += "<BR/><BR/>" + "PROVIDER SPECIALTIES:";
                            detail += "<BR/>" + ProviderSpecialty;

                            detail += "<BR/><BR/>" + "LANGUAGES:";
                            detail += "<BR/>" + Languages;

                            detail += "<BR/><BR/>" + "SPECIAlIZATIONS:";
                            detail += "<BR/>" + Specializations;

                            detail += "<BR/><BR/>" + "COUNTIES:";
                            detail += "<BR/>" + Counties;
                        }

                        if (GenderServed == "B")
                            GenderServed = "Served both Boys and Girls"
                        else if (GenderServed == "M")
                            GenderServed = "Served Boys Only"
                        else if (GenderServed == "F")
                            GenderServed = "Served Girls Only"

                        if (GenderServed != "")
                            detail += "<BR/>" + GenderServed;

                        if (AvailableBeds != "" && Admissions != "") {

                            let abed: number = +AvailableBeds;
                            let beds: number = +Admissions;
                            let intAdmission: number = 0;


                            if (abed <= 0)
                                detail += "<BR/>" + "Available Beds = 0";
                            else
                                detail += "<BR/>" + "Available Beds = " + abed.toString();

                            intAdmission = beds - abed;

                            if (intAdmission <= 0)
                                detail += "<BR/>" + "Admissions = 0";
                            else
                                detail += "<BR/>" + "Admissions =" + intAdmission.toString();

                        }
                        switch (showProviders) {
                            case this.SELECT_PROVIDERS_BY_CHECKBOXES:
                                {
                                    // get the referfence from the gridncheckbox 
                                    // that contains SiteType information
                                    let templateId_SiteType: number = 0;

                                    let data_SiteTypeTemplate: Array<NJDocDefTemplate> =
                                        gridNCheckBoxProivders.lstChildDocDefTemplate.filter(
                                            (d: NJDocDefTemplate) => {
                                                return (
                                                    (d.dictCustomParameters["Composite"] == siteType && d.dictCustomParameters["Composite"])
                                                    || (d.dictCustomParameters["SiteType"] == siteType && d.dictCustomParameters["SiteType"])
                                                )
                                            }
                                        )

                                    if (data_SiteTypeTemplate.length == 1)
                                        templateId_SiteType = data_SiteTypeTemplate[0].docDefTemplateID;
                                    if (gridNCheckBoxProivders.IsSelected(templateId_SiteType))
                                        this.loadProvider(location, this.map, providerName, detail);

                                    break;
                                }
                            case this.SELECT_ALL_PROVIDERS: {
                                this.loadProvider(location, this.map, providerName, detail);
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    private GetDistance(childLocation: google.maps.LatLng, providerLocation: google.maps.LatLng): number {
        let miles: number = 0;

        let R: number = 3958.8; // Radius of the Earth in miles
        let rlat1: number = childLocation.lat() * (Math.PI / 180); // Convert degrees to radians
        let rlat2: number = providerLocation.lat() * (Math.PI / 180); // Convert degrees to radians
        let difflat: number = rlat2 - rlat1; // Radian difference (latitudes)
        let difflon: number = (providerLocation.lng() - childLocation.lng()) * (Math.PI / 180); // Radian difference (longitudes)

        miles = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
        
        return miles;
    }

    loadProvider(location: google.maps.LatLng, map: google.maps.Map, title: string, detail: string, flagColor?: string, siteType?: string, refreshList?:boolean)
    {
        var marker;
        
        // Adds markers to the map.
        if (!flagColor)
            flagColor = "Brown";
        // Marker sizes are expressed as a Size of X,Y where the origin of the image
        // (0,0) is located in the top left of the image.

        // Origins, anchor positions and coordinates of the marker increase in the X
        // direction to the right and in the Y direction down.
        //const image = {
        //    url: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        //    // This marker is 20 pixels wide by 32 pixels high.
        //    size: new google.maps.Size(20, 32),
        //    // The origin for this image is (0, 0).
        //    origin: new google.maps.Point(0, 0),
        //    // The anchor for this image is the base of the flagpole at (0, 32).
        //    anchor: new google.maps.Point(0, 32)
        //};

        /////////////////////////////////////////////////////////
        /////////////////

        const image = {
            path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
            fillColor: flagColor,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 1,
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 32)
        };
        //////////////////
        //////////////////////////////////////////////////////////
        
        // Shapes define the clickable region of the icon. The type defines an HTML
        // <area> element 'poly' which traces out a polygon as a series of X,Y points.
        // The final coordinate closes the poly by connecting to the first coordinate.
        const shape = {
            coords: [1, 1, 1, 20, 18, 20, 18, 1],
            type: "poly"
        } as google.maps.MarkerShapePoly;

        const contentString = this.getContentDetail(title, detail);

        marker = new google.maps.Marker(
            {
                position: location
                , map: map
                , draggable: true
                , title: title 
                , icon: image
                , shape: shape
            }
        );

        const infowindow = new google.maps.InfoWindow({
            content: contentString,
            zIndex: 1010
        });

        marker.addListener("click", () => {
            infowindow.open(map, marker);
        });
        marker.addListener('mouseover', function () {
            infowindow.open(map, this);
        });
        // assuming you also want to hide the infowindow when user mouses-out
        marker.addListener('mouseout', function () {
            infowindow.close();
        });

        marker.setMap(map);

        if (siteType)
        {
            if (refreshList)
                this.LstProviderMarkers = [];
            let _ProvMarker: ProviderMarkers = { ProvType: siteType, Marker: marker, Location: location, Map: map, HexValue: flagColor, Detail: detail, Title: title };
            this.LstProviderMarkers.push(_ProvMarker);
        }

        this.addMarker(marker);
    }

    private childMarker = null;
    loadChild(locationLatLong: google.maps.LatLng, map: google.maps.Map, title: string) {
        //var marker;
        const goldStar = {
            path: "M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z",
            fillColor: "red",
            fillOpacity: 0.8,
            scale: 0.12,
            strokeColor: "red",
            strokeWeight: 1
        };

        const humanShape = {
            path: "M196.800 30.049 C 195.463 31.633,193.048 32.403,188.026 32.846 C 185.731 33.048,183.841 33.256,183.826 33.307 C 183.242 35.363,180.275 37.543,178.000 37.586 C 177.006 37.605,175.200 39.643,175.200 40.745 C 175.200 41.018,174.611 41.487,173.892 41.787 C 172.004 42.576,171.331 43.493,170.383 46.562 C 169.612 49.058,169.413 49.338,168.027 49.882 L 166.513 50.477 166.250 54.218 C 165.917 58.953,164.721 62.971,163.383 63.848 C 161.863 64.844,161.962 68.103,163.564 69.781 C 165.040 71.328,165.563 73.116,166.143 78.600 C 166.566 82.600,166.686 83.011,167.455 83.121 C 168.696 83.299,169.808 84.719,170.589 87.121 C 171.308 89.334,172.598 90.955,173.994 91.398 C 174.445 91.541,175.056 92.230,175.352 92.929 C 176.087 94.666,177.005 95.350,179.700 96.173 C 181.939 96.856,183.600 98.250,183.600 99.446 C 183.600 100.111,184.468 100.295,188.817 100.549 C 192.999 100.794,196.653 102.040,197.290 103.439 C 197.678 104.290,197.989 104.400,200.000 104.400 C 202.011 104.400,202.322 104.290,202.710 103.439 C 203.347 102.040,207.001 100.794,211.183 100.549 C 215.532 100.295,216.400 100.111,216.400 99.446 C 216.400 98.250,218.061 96.856,220.300 96.173 C 222.995 95.350,223.913 94.666,224.648 92.929 C 224.944 92.230,225.594 91.534,226.093 91.383 C 227.656 90.909,228.732 89.582,229.444 87.251 C 230.274 84.532,230.636 84.028,232.240 83.358 C 233.475 82.842,233.480 82.826,233.754 78.933 C 234.075 74.362,234.896 71.228,236.172 69.695 C 237.677 67.888,237.796 64.904,236.414 63.613 C 234.979 62.272,234.100 59.187,233.755 54.280 C 233.502 50.680,233.412 50.368,232.578 50.159 C 231.180 49.808,230.129 48.409,229.423 45.959 C 228.763 43.669,227.593 42.189,226.243 41.940 C 225.826 41.863,225.291 41.440,225.052 41.000 C 223.696 38.498,222.934 37.605,222.153 37.603 C 220.204 37.596,217.231 35.944,216.744 34.596 C 216.241 33.205,214.973 32.800,211.126 32.800 C 207.388 32.800,202.400 30.711,202.400 29.145 C 202.400 28.131,197.791 28.874,196.800 30.049 M186.462 135.475 C 185.182 135.604,184.386 135.986,183.446 136.925 C 181.857 138.510,179.378 139.220,174.456 139.500 L 170.712 139.714 170.154 141.049 C 169.501 142.611,168.504 143.305,165.928 143.990 C 164.063 144.486,162.688 145.582,161.844 147.246 C 161.600 147.727,161.065 148.319,160.655 148.561 C 159.006 149.532,157.760 151.196,157.000 153.439 C 156.355 155.344,155.943 155.928,154.868 156.465 C 154.136 156.831,153.468 157.199,153.384 157.282 C 153.300 157.366,153.051 159.317,152.831 161.617 C 152.339 166.753,151.495 169.358,149.955 170.496 L 148.800 171.350 148.800 212.288 C 148.800 247.649,148.879 253.255,149.379 253.447 C 150.391 253.836,152.149 256.499,152.622 258.361 C 153.048 260.041,153.206 260.200,155.030 260.780 C 156.210 261.155,157.150 261.739,157.407 262.257 C 158.140 263.738,158.817 264.340,160.052 264.611 C 162.022 265.044,162.000 264.577,162.000 306.435 L 162.000 346.017 162.914 346.433 C 163.974 346.917,165.997 349.932,166.005 351.042 C 166.019 352.922,166.478 353.579,167.944 353.816 C 168.745 353.945,169.850 354.253,170.400 354.501 C 172.383 355.393,175.658 355.915,175.866 355.372 C 176.080 354.814,177.701 354.099,179.159 353.919 C 179.687 353.853,180.243 353.530,180.395 353.200 C 181.617 350.545,181.925 350.168,183.213 349.748 L 184.600 349.296 184.863 328.948 C 185.187 303.881,185.561 299.983,187.950 296.800 L 189.000 295.400 189.200 276.200 L 189.400 257.000 190.405 255.205 C 193.598 249.503,207.064 249.756,209.753 255.569 C 210.569 257.332,210.607 258.111,210.800 276.624 L 211.000 295.848 212.089 297.142 C 214.383 299.866,214.813 304.386,215.136 329.165 L 215.400 349.329 216.800 349.799 C 218.093 350.232,218.423 350.632,219.605 353.200 C 219.757 353.530,220.313 353.853,220.841 353.919 C 222.299 354.099,223.920 354.814,224.134 355.372 C 224.342 355.915,227.617 355.393,229.600 354.501 C 230.150 354.253,231.255 353.945,232.056 353.816 C 233.522 353.579,233.981 352.922,233.995 351.042 C 234.003 349.932,236.026 346.917,237.086 346.433 L 238.000 346.017 238.000 306.435 C 238.000 264.577,237.978 265.044,239.948 264.611 C 241.183 264.340,241.860 263.738,242.593 262.257 C 242.850 261.739,243.790 261.155,244.970 260.780 C 246.794 260.200,246.952 260.041,247.378 258.361 C 247.851 256.499,249.609 253.836,250.621 253.447 C 251.121 253.255,251.200 247.668,251.200 212.442 L 251.200 171.658 250.254 170.914 C 248.378 169.438,247.504 166.500,246.979 159.900 C 246.776 157.352,246.611 156.800,246.055 156.800 C 244.735 156.800,243.673 155.594,242.975 153.304 C 242.222 150.831,241.216 149.443,239.622 148.679 C 239.073 148.416,238.437 147.840,238.209 147.400 C 237.413 145.865,235.787 144.558,234.000 144.018 C 231.421 143.238,230.480 142.565,229.846 141.049 L 229.288 139.714 225.544 139.500 C 220.492 139.213,218.152 138.520,216.430 136.800 L 215.027 135.400 201.614 135.350 C 194.236 135.323,187.418 135.379,186.462 135.475",
            fillColor: "black",
            fillOpacity: 0.8,
            scale: 0.12,
            strokeColor: "red",
            strokeWeight: 1
        };

        if (this.childMarker == null) {
            this.childMarker = new google.maps.Marker({
                position: locationLatLong,
                icon: humanShape,
                title: title,
                map: map
            });
        }
        else {
            this.childMarker.position = locationLatLong;
        }

        // clear the existing first
        this.childMarker.setMap(null);
        this.childMarker.setMap(map)

        this.addMarker(this.childMarker);
    }


    private zipMarker = null;
    loadZipmarker(locationLatLong: google.maps.LatLng, map: google.maps.Map, title: string) {
        //var marker;
        const goldStar = {
            path: "M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z",
            fillColor: "blue",
            fillOpacity: 0.8,
            scale: 0.12,
            strokeColor: "blue",
            strokeWeight: 1
        };

        if (this.zipMarker == null)
            this.zipMarker = new google.maps.Marker({
                position: locationLatLong,
                icon: goldStar,
                title: title,
                map: map
            });
        else
            this.zipMarker.position = locationLatLong;


        // clear the existing first
        this.zipMarker.setMap(null);
        this.zipMarker.setMap(map)
        this.addMarker(this.zipMarker);
    }

    getContentDetail(heading: string, detail: string) {
        const contentString =
            '<div id="content">' +
            '<div id="siteNotice"></div>' +
            'PROVIDER NAME:<br/>' + heading +
            '<div id="bodyContent">' +
            "<p>" +
            detail
        "</p>" +
            "</div>" +
            "</div>";
        return contentString;
    }

    public dismiss(DismissReason: string = 'Dismiss!') {
        this.activeModal.close(DismissReason);
    }

    private primitives: Array<DOData>;
    public initializedDefault: boolean = false;
    sectionGrid_tableAfterViewInit(c: SectionTableComponent) {
        if (c.TextBoxComponents.length > 0) {
            if (this.siteCIMIDRequired) {
                this.primitivesGrid = c;
                this.primitives = c.getPrimitives();
                this.showProviderTypeInfo();
            }
            else {
                this.primitivesGrid = c;
                this.primitives = c.getPrimitives();
            }

            if (!this.initializedDefault) {
                this.setDefaultCheckBoxes();
                this.initializedDefault = true;
            }
        }
    }

    istableAfterViewChecked: boolean = false;
    sectionGrid_tableAfterViewChecked(c: SectionTableComponent) {
        if (this.siteCIMIDRequired && !this.istableAfterViewChecked) {
            this.primitivesGrid = c;
            if (this.checkDataInGrid(c)) {
                this.loadProviders(this.SELECT_ALL_PROVIDERS);
                this.istableAfterViewChecked = true;
            }
            if (!this.reOpenPopup)
                this.dismiss("ReOpen!");
        }
    }

    private checkDataInGrid(c: SectionTableComponent) 
    {
        let lat: Number;
        let long: Number;

        let grdProivders: GridInternalAgGridComponent = this.primitivesGrid.GridInternalAgGridComponents.first;

        // get template ids
        let templateId_lat: Number;
        let templateId_long: Number;
        let location: google.maps.LatLng;

        for (let template of grdProivders.lstChildDocDefTemplate)
        {
            if (template.dictCustomParameters['Lat'] == "Yes")
                templateId_lat = template.docDefTemplateID;
            if (template.dictCustomParameters['Long'] == "Yes")
                templateId_long = template.docDefTemplateID;
        }

        let lstDocDataLocal: Array<NJDocData> = new Array<NJDocData>();

        if (grdProivders.lstDocData) 
        {
            lstDocDataLocal = grdProivders.lstDocData;
        }
        
        for (var rowIndex = 0; rowIndex < grdProivders._getRows.length; rowIndex++) 
        {
            let docDataRowID = grdProivders._getRows[rowIndex];


            let data_lat: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_lat && templateId_lat) });
            if (data_lat.length == 1)
                lat = Number(data_lat[0].dataValue);
            else
                lat = Number(0);

            let data_long: Array<NJDocData> = lstDocDataLocal.filter((d: NJDocData) => { return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == templateId_long && templateId_long) });
            if (data_long.length == 1)
                long = Number(data_long[0].dataValue);
            else
                long = Number(0);

            // *************************************************
            // if no geo data nothing to load for the provider
            // *************************************************
            if (lat != 0 && long != 0)
            {
                return true;
            }
        }

        return false;
    }

    private wait(ms) {
        var start = new Date().getTime();
        var end = start;
        while (end < start + ms) {
            end = new Date().getTime();
        }
    }


    private setDefaultCheckBoxes() {
        let ChildVisibleCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.customParameters['config'] == 'Yes')[0];
        if (ChildVisibleCheckBox != null) 
            ChildVisibleCheckBox.selectCheckBoxes();
    }

    private showProviderTypeInfo() {

        let Label_providerTypelbl: DOLabelComponent = this.primitivesGrid.DOLabelComponents.filter
            (DOLabelComponent => DOLabelComponent.DocDefTemplate.templateCode == "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_Label_ProviderType")[0];

        let Label_providerSpecialtylbl: DOLabelComponent = this.primitivesGrid.DOLabelComponents.filter
            (DOLabelComponent => DOLabelComponent.DocDefTemplate.templateCode == "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_Label_ProviderSpecial")[0];

        let Label_providerType: DOLabelComponent = this.primitivesGrid.DOLabelComponents.filter
            (DOLabelComponent => DOLabelComponent.DocDefTemplate.templateCode == "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_Label")[0];

        let Label_providerSpecialty: DOLabelComponent = this.primitivesGrid.DOLabelComponents.filter
            (DOLabelComponent => DOLabelComponent.DocDefTemplate.templateCode == "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_Label_24731")[0];

        let Label_program: DOLabelComponent = this.primitivesGrid.DOLabelComponents.filter
            (DOLabelComponent => DOLabelComponent.DocDefTemplate.templateCode == "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_24717_Label_47004")[0];

        if (this.providerType == "") {

            Label_providerType.isHidden = true;
            Label_providerSpecialty.isHidden = true;
            Label_providerTypelbl.isHidden = true;
            Label_providerSpecialtylbl.isHidden = true;
            Label_program.lblDocDefTemplate.tLabel = this.program;
        }
        else {
            Label_providerType.lblDocDefTemplate.tLabel = this.providerType;
            Label_providerSpecialty.lblDocDefTemplate.tLabel = this.providerSpecialty;
            Label_program.lblDocDefTemplate.tLabel = this.program;
        }
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private SELECT_ALL_PROVIDERS: Number = 1;
    private SELECT_PROVIDERS_BY_CHECKBOXES: Number = 0;

    btnSelectAll(cbTemplateCode:string)
    {
        let _lstDocData: DOData[][] = this.DeepCopyDOData(this.listDocdata);
        if (!this.SelectedCBGroup)
            this.SelectedCBGroup = this.GetDODataItem(cbTemplateCode, _lstDocData);
        let _templCode: string = this.SelectedCBGroup.njDocDefTemplate.templateCode;
        let curCheckbox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.DocDefTemplate.templateCode == _templCode)[0];
        curCheckbox.selectCheckBoxes();
        let _currentCBList: DOData = this.GetDODataItem(_templCode, _lstDocData)

        this.SelectedCBGroup.lstDocData.forEach(x =>
        {
            x.dataValue = "1";
        });
        _currentCBList.lstDocData.forEach(x =>
        {
            x.dataValue = "1";
            let _cbData: DOData = new DOData;
            _cbData.njDocDefTemplate.dictCustomParameters = {};
            _cbData.njDocData.dataValue = x.dataValue;
            _cbData.njDocData.docDataHdrId = x.docDataHdrId;
            _cbData.njDocData.docDefDataRowID = x.docDefDataRowID;
            _cbData.njDocData.docDefTemplateID = x.docDefTemplateID;
            _cbData.njDocDefTemplate.tLabel = _currentCBList.lstChildDocDefTemplate.find(cdd => cdd.docDefTemplateID == x.docDefTemplateID).tLabel;
            _cbData.njDocDefTemplate.dictCustomParameters["Composite"] = _currentCBList.lstChildDocDefTemplate.find(cdd => cdd.docDefTemplateID == x.docDefTemplateID).dictCustomParameters["Composite"];
            //HexValue
            let hexVal: string = _currentCBList.lstChildDocDefTemplate.find(cdd => cdd.docDefTemplateID == x.docDefTemplateID).dictCustomParameters["HexValue"];
            if (hexVal)
                _cbData.njDocDefTemplate.dictCustomParameters["HexValue"] = _currentCBList.lstChildDocDefTemplate.find(cdd => cdd.docDefTemplateID == x.docDefTemplateID).dictCustomParameters["HexValue"];

            this.loadProviders(this.SELECT_PROVIDERS_BY_CHECKBOXES, _cbData);
        });
        if (this.childChecked)
            this.loadChild(this.ChildLocation, this.map, "");
        this.listDocdata = [];
        this.changeDetectorRef.detectChanges();
        this.listDocdata = _lstDocData;
        this.changeDetectorRef.detectChanges();
    }

    btnSelectNone(cbTemplateCode: string)
    {
        let _lstDocData: DOData[][] = this.DeepCopyDOData(this.listDocdata);
        if (!this.SelectedCBGroup)
            this.SelectedCBGroup = this.GetDODataItem(cbTemplateCode, _lstDocData);
        let _templCode: string = this.SelectedCBGroup.njDocDefTemplate.templateCode;
        let curCheckbox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.DocDefTemplate.templateCode == _templCode)[0];
        let _currentCBList: DOData = this.GetDODataItem(_templCode, _lstDocData);
        curCheckbox.clearCheckBoxes();
        this.LstProviderMarkers = [];
        this.clearMarkers();
        this.deleteMarkers();
        if (this.childChecked)
            this.loadChild(this.ChildLocation, this.map, "");
        this.SelectedCBGroup.lstDocData.forEach(x =>
        {
            x.dataValue = "0";
        });
        _currentCBList.lstDocData.forEach(x =>
        {
            x.dataValue = "0";
        });
        this.listDocdata = [];
        this.changeDetectorRef.detectChanges();
        this.listDocdata = _lstDocData;
        this.changeDetectorRef.detectChanges();
    }

    ///**
    //* Responds to click events
    //*
    //* 
    //*/
    onClickButton(d: DOData) {
        if (d.customParameters['MapExit'] != null) {
            this.dismiss();
        }
        else if (d.customParameters['MapSelectAll'] != null) {
            this.SelectAllCheckboxes(true);
            this.clearMarkers();

            let providerTypeDropDown = this.primitivesGrid.DropDownsComponents.filter(x => x.DocDefTemplate.templateCode == 'Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_DropDown_ProviderType');

            if (providerTypeDropDown != null) {
                if (providerTypeDropDown.length > 0) {
                    this.SiteTypeFromDropDownSelection = providerTypeDropDown[0].selectedLookup.shortDesc; 
                }
            }

            this.loadProviders(this.SELECT_ALL_PROVIDERS);
        }
        else if (d.customParameters['MapSelectNone'] != null) {
            this.SelectAllCheckboxes(false);
            this.clearMarkers();
        }
        else if (d.customParameters['MapCaseload'] != null) {
            this.searchForYouth(d, "CSA", this.diaglogType_MyCaseload);
        }
        else if (d.customParameters['MapAgencyCases'] != null) {
            this.searchForYouth(d, "CSA", this.diaglogType_AgencyCases);
        }
        else if (d.customParameters['MapShowProviders'] != null) {
            this.loadProviders(this.SELECT_ALL_PROVIDERS);
        }
        else if (d.customParameters['MapMemberSearch'] != null) {
            let DOTextBoxComponent_Zip: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.filter(TextBoxComponent => TextBoxComponent.DocDefTemplate.templateCode == d.customParameters['MapMemberSearchZIPTCode'])[0];
            if (DOTextBoxComponent_Zip.DocData.dataValue == "") {
                this.loadMember(d.customParameters['MapMemberSearchMIDTCode']);
            }
            else {
                let zipCode: string = DOTextBoxComponent_Zip.DocData.dataValue;
                this.loadzip(zipCode,"","");
            }
        }
        switch (d.njDocDefTemplate.templateCode)
        {
            case "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_Button_SelectAll":
                {
                    this.btnSelectAll("Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType");
                }
                break;
            case "Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_Button_SelectNone":
                {
                    this.btnSelectNone("Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType");
                    this.btnSelectNone("Wrappers_ProviderGEOMap_DynamicGrid_ControlsinGeoMa_CheckBox_ShowCountyAreas");
                }
                break;
            case "Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_Button_SelectAll":
                {
                    this.btnSelectAll("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType");
                }
                break;
            case "Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_Button_SelectNone":
                {
                    this.btnSelectNone("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType");

                }

                break;
            case "Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_DropDown_ProviderType":
                {
                    let _lstDocData: DOData[][] = this.DeepCopyDOData(this.listDocdata);
                    let cbProvBH: DOData = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType", _lstDocData);
                    let cbProvIDD: DOData = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeIDD", _lstDocData);
                    let cbProvSU: DOData = this.GetDODataItem("Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeSA", _lstDocData);
                    let _Selection: string = d.lstDocDefTemplateLookup.find(x => x.lookupId == +d.njDocData.dataValue).shortDesc;
                    let ProvBHCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.DocDefTemplate.templateCode == 'Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderType')[0];
                    let ProvIDDCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.DocDefTemplate.templateCode == 'Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeIDD')[0];
                    let ProvSUCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.DocDefTemplate.templateCode == 'Wrappers_OOHProviderGEOM_DynamicGrid_ControlsinGeoMa_GridNCheckBox_ProviderTypeSA')[0];
                    ProvBHCheckBox.clearCheckBoxes();
                    ProvIDDCheckBox.clearCheckBoxes();
                    ProvSUCheckBox.clearCheckBoxes();
                    cbProvBH.lstDocData.forEach(x =>
                    {
                        x.dataValue = "0";
                    });
                    cbProvIDD.lstDocData.forEach(x =>
                    {
                        x.dataValue = "0";
                    });
                    cbProvSU.lstDocData.forEach(x =>
                    {
                        x.dataValue = "0";
                    });
                    this.deleteMarkers();
                    this.ProviderTypeSelection = _Selection;
                    switch (_Selection)
                    {
                        case "BH":
                            cbProvBH.customParameters['Hidden'] = "No";
                            cbProvIDD.customParameters['Hidden'] = "Yes";
                            cbProvSU.customParameters['Hidden'] = "Yes";
                            this.SelectedCBGroup = cbProvBH;
                            break;
                        case "IDD":
                            cbProvBH.customParameters['Hidden'] = "Yes";
                            cbProvIDD.customParameters['Hidden'] = "No";
                            cbProvSU.customParameters['Hidden'] = "Yes";
                            this.SelectedCBGroup = cbProvIDD;
                            break;
                        case "SU":
                            cbProvBH.customParameters['Hidden'] = "Yes";
                            cbProvIDD.customParameters['Hidden'] = "Yes";
                            cbProvSU.customParameters['Hidden'] = "No";
                            this.SelectedCBGroup = cbProvSU;
                            break;
                    }

                    this.listDocdata = [];
                    this.changeDetectorRef.detectChanges();
                    this.listDocdata = _lstDocData;
                    this.changeDetectorRef.detectChanges();
                }
        }
    }
    
    SelectAllCheckboxes(SelectCheckboxes: boolean) {
        let ProviderTypeCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.customParameters['MapProviderCheckGrid'] == 'Yes')[0];

        if (ProviderTypeCheckBox != null) {
            if (SelectCheckboxes)
                ProviderTypeCheckBox.selectCheckBoxes();
            else
                ProviderTypeCheckBox.clearCheckBoxes();
        }


        let ChildVisibleCheckBox: GridNCheckboxComponent = this.primitivesGrid.GridNCheckboxComponents.filter(GridNCheckboxComponent => GridNCheckboxComponent.customParameters['config'] == 'Yes')[0];
        if (ChildVisibleCheckBox != null) {

            //let templateItem: NJDocDefTemplate[] = ChildVisibleCheckBox.lstChildDocDefTemplate.filter(x => x.customParameters['MapChildVisible'] == 'Yes');
            let templateItem = ChildVisibleCheckBox.lstChildDocDefTemplate.filter(x => x.dictCustomParameters['MapChildVisible'] === 'Yes');

            if (SelectCheckboxes)
                ChildVisibleCheckBox.selectedCheckBox(templateItem[0].docDefTemplateID);
            else 
                ChildVisibleCheckBox.unSelectedCheckBox(templateItem[0].docDefTemplateID);
        }
    }

    loadzip(zipCode: string, city: string, state: string) {
        const geocoder = new google.maps.Geocoder();

        let address: string = zipCode;

        if (city != "" && state !="") {

            address = city + ", " + state + ", " + zipCode;
        }

        geocoder.geocode({ address: address }, (results, status) => {
            if (status === "OK") {
                this.loadZipmarker(results[0].geometry.location, this.map, "Zip");
            } else {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }


    private currenZip: string = "";
    private zipData: Array<DOData>;
    private openZip(zip: string) {

        this.currenZip = zip;
        const modalRef = this.wrapLib.GetZipPromise(zip);
        modalRef.result.then((result) => {
            if (result) {
                this.zipData = this.DeepCopy(result); 

                console.log(result);

                this.updatePrimitives(this.zipData);
            }
        }, (reason) => {
            const closeResult = `Dismissed ${this.wrapLib.getDismissReason(reason)}`;
            console.log(closeResult);
        });
    }


    private updatePrimitives(zipData: Array<DOData>) {
        let city: string = "";
        let state: string = "";

        if (zipData !== null) {
            city = zipData[0].njDocData.dataValue;
            state = zipData[2].njDocData.dataValue;
        }

        if (city === "" && state === "") {
            this.loadzip(this.currenZip, "", "");
        }
        else {
            if (city != "" && state != "") {
                this.loadzip(this.currenZip, city, state);
            }
        }
    }

    setLoaderMemberId(gridTemplateCode: string, MemberId: string, loaderKey: string) {

        let lstDocData: DocdefDataVM = new DocdefDataVM();
        let txtDocData: NJDocData;

        // first parameter (MemberID)
        txtDocData = new NJDocData();
        txtDocData.dataValue = MemberId;
        txtDocData.docDefTemplateID = 100;
        lstDocData.loaderKey = loaderKey;
        lstDocData.docdata.push(txtDocData);

        this.data.doSetLoaderMemberId(lstDocData)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                    }
                },
                (err: any) => console.log(err),
                () => {

                    this.loadMember(gridTemplateCode);
                }
            );
    }


    loadMember(gridTemplateCode: string) {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tab;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = gridTemplateCode;

        let LastAccodionButon = gridTemplateCode;
        this.data.loadGridData(LastAccodionButon, params, this.loaderKey)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        let localGridData = new Array<NJDocData>();
                        if (this.data.gridDataVM.docdata)
                            for (let lstData of this.data.gridDataVM.docdata) {
                                localGridData.push(DocDefPrimLibService.createNew(lstData));
                            };

                        this.getAddressInformation(localGridData);
                    }
                },
                (err: any) => console.log(err),
                () => {
                    //this.ModalWait.close("");
                }
            );
    }

    getAddressInformation(aryNJDocData: Array<NJDocData>) {

        let address1: String ="";
        let city: String = "";
        let State: String = "";
        let Zip: String = "";

        if (aryNJDocData.length > 0) {
            address1 = aryNJDocData[0].dataValue;
            city = aryNJDocData[3].dataValue;
            State = aryNJDocData[1].dataValue;
            Zip = aryNJDocData[2].dataValue;
        }

        // *************************************************
        // if no geo data nothing to load for the provider
        // *************************************************
        if ((address1 != "") && (city != "") && (State != "") && (Zip != "")) {

            const address: string = address1 + " " + city + " " + State + " " + Zip;

            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: address }, (results, status) => {
                if (status === "OK") {
                    this.ChildLocation = results[0].geometry.location;

                    this.loadChild(results[0].geometry.location, this.map, "Child");
                } else {
                    alert("Geocode was not successful for the following reason: " + status);
                }
            });

        } // if

    }

    onShowCountyArea(showCoutyArea: boolean) {
        if (showCoutyArea) {
            this.removeCountyLayer();
            this.loadCountyLayer();
        }
        else
            this.removeCountyLayer();
    }

    childChecked: boolean = true;
    onclickChkbox(d: DOData) {
        // county areas
        if (d.njDocDefTemplate.dictCustomParameters['MapCountyArea'] != null) {
            let isChecked: boolean;
            if (d.njDocData.dataValue === "1")
                isChecked = true;
            else
                isChecked = false;
            this.onShowCountyArea(isChecked);
        }

        // child visible
        if (d.njDocDefTemplate.dictCustomParameters['MapChildVisible'] != null) {

            //let isChecked: boolean;
            if (d.njDocData.dataValue === "1")
                this.childChecked = true;
            else
                this.childChecked = false;

            if (!this.childChecked)
                this.childMarker.setMap(null);
            else
                this.childMarker.setMap(this.map);
        }

        // provider check
        if (d.njDocDefTemplate.dictCustomParameters['MapProviderTypeCheck'] != null) 
        {
            this.clearMarkers();
            this.loadProviders(this.SELECT_PROVIDERS_BY_CHECKBOXES);
        }
        if (d.njDocDefTemplate.dictCustomParameters['MapShowProviders'] != null)
        {
            this.loadProviders(this.SELECT_PROVIDERS_BY_CHECKBOXES, d);
        }
    }

    clearDeselectedProviderMarker(provCode: string)
    {
        this.LstProviderMarkers = this.LstProviderMarkers.filter(x => x.ProvType != provCode);
        //let map = new Map();
       // let _lstProvMark: any = setTimeout(this.DeepCopy, 0, this.LstProviderMarkers);//this.DeepCopy(this.LstProviderMarkers);
        
        this.deleteMarkers();
        this.loadChild(this.ChildLocation, this.map, "");
        let _refreshList: boolean = true;
        this.LstProviderMarkers.forEach(x =>
        {
            this.loadProvider(x.Location, x.Map, x.Title, x.Detail, x.HexValue, x.ProvType, _refreshList);//location: google.maps.LatLng, map: google.maps.Map, title: string, detail: string, siteType?: string
            _refreshList = false;
        });
    }

    /// Marker management
    // Adds a marker to the map and push to the array.
    public LstProviderMarkers: ProviderMarkers[] = [];
    addMarker(marker: google.maps.Marker) //location: google.maps.LatLng, map: google.maps.Map, title: string, detail: string, siteType?: string
    {
        this.markers.push(marker);
    }
    // Sets the map on all markers in the array.
    setMapOnAll(map: google.maps.Map | null) {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    }
    // Removes the markers from the map, but keeps them in the array.
    clearMarkers() {
        this.setMapOnAll(null);
    }
    // Shows any markers currently in the array.
    showMarkers() {
        this.setMapOnAll(this.map);
    }
    // Deletes all markers in the array by removing references to them.
    deleteMarkers() {
        this.clearMarkers();
        this.markers = [];
    }

    searchForYouth(d: DOData, userType: string, diaglogType: string) {
        try {
            let _childData: childSearchReq = new childSearchReq();

            if (this.MemberID) 
            {
                _childData.memberID = this.MemberID;
            }
            if (diaglogType) 
            {
                _childData.memberID = "";
                _childData.returnData = true;
                if (diaglogType == this.diaglogType_MyCaseload)
                {
                    _childData.title = "My Caseload";
                    _childData.content = "";
                    _childData.gridTemplateCode = "Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr";
                    _childData.tab = "Wrappers_Tab_SelectaMemberID_15602";
                }
                else 
                {
                    _childData.title = "Agency Cases";
                    _childData.content = "";
                    _childData.gridTemplateCode = "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr";
                    _childData.tab = "Wrappers_Tab_SelectaMemberID";
                }
            }

            _childData.DOB = "";
            _childData.firstName = "";
            _childData.lastName = "";
            _childData.SSN = "";

            let currentDiagType: string = this.diaglogType_MyCaseload;

            const modalRef = this.wrapLib.GetSearchPromise(_childData);

            modalRef.result.then((result:DOData[]) => {
                if (result) {
                    if (result.length > 0) {
                        let d = result.filter(function (item) 
                        {
                            if (diaglogType == currentDiagType)
                                return item.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr_TextBox_YouthChildID';
                            else
                                return item.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr_TextBox_YouthChildID';
                        });

                        let mid = this.primitivesGrid.TextBoxComponents.first;
                        mid.DocData.dataValue = d[0].njDocData.dataValue;
                        mid.onBlurText();

                        let lat: string = ""; 
                        let long: string = ""; 

                        if (diaglogType == currentDiagType) {
                            lat = result.find(x => x.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr_TextBox_LAT").njDocData.dataValue;
                            long = result.find(x => x.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr_TextBox_LONG").njDocData.dataValue;
                        }
                        else {
                            lat = result.find(x => x.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr_TextBox_LAT").njDocData.dataValue;
                            long = result.find(x => x.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr_TextBox_LONG").njDocData.dataValue;
                        }

                        if (lat != "" && long != "") {
                            this.ChildLocation = new google.maps.LatLng(Number(lat), Number(long));
                            this.loadChild(this.ChildLocation, this.map, "");
                        }

                        this.setLoaderMemberId(mid.customParameters['MapMemberSearchMIDTCode'], d[0].njDocData.dataValue, this.loaderKey)

                        // set loader memberid
                        //this.loadMember(mid.customParameters['MapMemberSearchMIDTCode']);
                    }
                }
            }, (reason) => {
                const closeResult = `Dismissed ${this.wrapLib.getDismissReason(reason)}`;
            });

        }
        catch (error) {
            alert("search error - " + error);

        }
    }

    @HostListener('window:keydown', ['$event'])

    handleKeyDown(event: KeyboardEvent) {

        if (event.key === "Enter") {

            // MapChildID
            // MapZipCode
            let zipCodeData: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.find(x => x.customParameters["MapZipCode"] == "Yes");

            let zipCode = zipCodeData.DocData.dataValue;

            if (zipCode.trim() === "") {
                let memberData: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.find(x => x.customParameters["MapChildID"] == "Yes");
                let membeId = memberData.DocData.dataValue;

                if (membeId != "") {
                    this.setLoaderMemberId(memberData.customParameters['MapMemberSearchMIDTCode'], membeId, this.loaderKey)
                }
            }
            else {
                this.openZip(zipCode);

                //this.loadzip(zipCode);
            }
        }
    }

    ChildLocation: google.maps.LatLng;
    DeepCopyDOData(lstDOData: DOData[][]): any
    {
        let outObject, value, key;

        if (typeof lstDOData !== "object" || lstDOData === null)
        {
            return lstDOData // Return the value if inObject is not an object
        }

        // Create an array or object to hold the values
        outObject = Array.isArray(lstDOData) ? [] : {}

        for (key in lstDOData)
        {
            value = lstDOData[key]

            // Recursively (deep) copy for nested objects, including arrays
            outObject[key] = this.DeepCopyDOData(value);
        }

        return outObject
    }

    DeepCopy(whatever: any): any
    {
        let outObject, value, key;

        if (typeof whatever !== "object" || whatever === null)
        {
            return whatever // Return the value if inObject is not an object
        }

        // Create an array or object to hold the values
        outObject = Array.isArray(whatever) ? [] : {}

        for (key in whatever)
        {
            value = whatever[key]

            // Recursively (deep) copy for nested objects, including arrays
            outObject[key] = this.DeepCopy(value);
        }

        return outObject
    }

    
}

export class ProviderMarkers
{
    ProvType: string;
    Marker: google.maps.Marker;
    Location: google.maps.LatLng;
    Map: google.maps.Map;
    Title: string;
    Detail: string;
    HexValue: string;
}
//title: string, detail: string